module.exports = __webpack_public_path__ + "img/service-phone.8380fda9.png";